import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();


export const upload = (data, location, documentType,label, src, loanNumber,cancelToken, callback) => {
  // console.log('data', data);
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    let formData = new FormData();
    for (const key of Object.keys(data)) {
      formData.append(`packet`, data[key]);
    }
    // formData.append(`packet`, data);
    formData.append(`location`, location);
   // formData.append(`type`, documentType);
    formData.append(`document_type`, label);
    formData.append(`src`, src);
    formData.append(`loanNumber`, loanNumber);

    ApiClient.postFormData(`${apiUrl}${PORT}/upload`, formData, token, dispatch,cancelToken).then((response) => {
      if (response) {
        // dispatch({ type: "LOGIN", data: response });
        // toast.success(response.message, toasterConfig);
        return callback(response);

      } else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg)
      }
    });
  }
};

export const getPrivileges = (params,callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.get(`${apiUrl}${PORT}/upload`,params, token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      } else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg)
      }
    });
  }
};

export const loader = (flag) => {
  return (dispatch) => {
    dispatch({ type: "ISLOADING", data: flag });
  }
}